import axios from "axios";
import { BASE_URL, LOGIN_URL } from './common';

export const ME_URL = "api/me";

export function getDoorList() {

  var url = BASE_URL + 'door?pageSize=10000'

  return axios.get(url);
}

export function registerDoor(nm, descs, deviceIds) {

  var params = { nm, descs, deviceIds: deviceIds.join(',') };
  var paramStr = Object.keys(params).map(key => `${key}=${encodeURIComponent(params[key])}`).join('&');
  var url = BASE_URL + 'door?' + paramStr;

  return axios.post(url, params);
}

export function deleteDoor(doorId) {
  var url = BASE_URL + 'door/' + doorId;

  return axios.delete(url);
}